var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(
              "c-table",
              {
                ref: "table",
                attrs: {
                  title: "장소별 라인 목록",
                  columns: _vm.grid.columns,
                  data: _vm.lines,
                  usePaging: false,
                  selection: "multiple",
                  rowKey: "lineId",
                  editable: _vm.editable,
                },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.pick.placeId
                          ? _c("c-btn", {
                              attrs: { label: "삭제", icon: "remove" },
                              on: { btnClicked: _vm.deleteLine },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.pick.placeId
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                showLoading: false,
                                icon: "add",
                              },
                              on: { btnClicked: _vm.addLine },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }